import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function AuthCallbackPage() {
  const { completeCallback } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    completeCallback(window.location.href)
      .then(() => setDone(true))
      .catch((caught) => setError(caught instanceof Error ? caught.message : 'Could not complete sign in'));
  }, [completeCallback]);

  if (done) {
    return <Navigate to="/clients" replace />;
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-bone text-ink">
      <div className="rounded-sm bg-white p-6 text-center shadow-soft ring-1 ring-ink/10">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-ink/20 border-t-ink" />
        <p className="text-sm font-medium">{error ?? 'Completing sign in'}</p>
      </div>
    </main>
  );
}
